import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { translate } from '@/core/utils/translate';
import { getApiErrorMessage } from './errorMessage';
import { refreshAccessToken } from './RefreshToken';

// İstek yenileme için maksimum deneme sayısı
const MAX_RETRY_ATTEMPTS = 3;

const getStore = async () => {
  const storeModule = await import('@/store/store');
  return storeModule.store;
};

const dispatchAuthAction = async (type: 'auth/logout', payload?: unknown) => {
  const reduxStore = await getStore();
  reduxStore.dispatch({ type, payload });
};

export const errorInterceptor = async (
  error: AxiosError
): Promise<AxiosResponse | Promise<AxiosError>> => {
  const originalRequest = error.config as AxiosRequestConfig & { _retry?: number };

  if (!originalRequest) {
    return Promise.reject(error);
  }

  if (error.response && error.response.status === 401) {
    if (originalRequest._retry && originalRequest._retry >= MAX_RETRY_ATTEMPTS) {
      void error;
      // Kullanıcıyı çıkış yaptır
      await dispatchAuthAction('auth/logout');

      return Promise.reject(new Error(translate('errors/api:retry_exhausted_logout')));
    }

    originalRequest._retry = (originalRequest._retry || 0) + 1;

    const newAccessToken = await refreshAccessToken();

    if (!newAccessToken) {
      return Promise.reject(new Error(translate('errors/api:token_refresh_failed')));
    }

    originalRequest.headers = originalRequest.headers || {};
    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

    return axios(originalRequest);
  }

  handleHttpError(error);

  return Promise.reject(error);
};

function handleHttpError(error: AxiosError): void {
  try {
    const apiErrorMessage = getApiErrorMessage(error);
    if (apiErrorMessage) {
      error.message = apiErrorMessage;
    }

    if (error.response) {
      // Sunucu yanıt hatası (400, 403, 404, 500 vb.)
      const status = error.response.status;

      switch (status) {
        case 400:
          void error;
          break;
        case 403:
          void error;
          break;
        case 404:
          void error;
          break;
        case 500:
          void error;
          break;
        default:
          void error;
      }
    } else if (error.request) {
      // İstek gönderildi ancak yanıt alınamadı (ağ hatası)
      void error;
    } else {
      // İstek oluşturma sırasında hata
      void error;
    }

    // URL bilgisini logla
    if (error.config && error.config.url) {
      void error;
    }
  } catch (logError) {
    void error;
  }
}
